const typography = {
    fontFamily: "MarkPro, sans-serif",
};

export default typography;
